module.exports = __webpack_public_path__ + "img/20.b2d20b67.jpg";